var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2441 4.87287C11.6428 4.41241 12.3572 4.41241 12.7559 4.87287L15.7632 8.34535C16.3241 8.99299 15.864 10 15.0073 10H8.99275C8.136 10 7.67594 8.99299 8.23682 8.34535L11.2441 4.87287Z",
    fill: "#A799A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7559 19.1271C12.3572 19.5876 11.6428 19.5876 11.2441 19.1271L8.23682 15.6547C7.67594 15.007 8.136 14 8.99275 14L15.0073 14C15.864 14 16.3241 15.007 15.7632 15.6547L12.7559 19.1271Z",
    fill: "#A799A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortTableIcon);
export default __webpack_public_path__ + "static/media/sortTableIcon.df840f7f41334c7d745bb4fc857c3f85.svg";
export { ForwardRef as ReactComponent };